module.exports = __webpack_public_path__ + "landing_static/img/header-sm.f1739038.png";